import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/kaggle': {
    width: 291,
    height: 512,
    paths: [
      {
        d: 'M291.7 509C291.2 511 289.2 512 285.7 512H218.8C214.8 512 211.3 510.2 208.3 506.7L97.7 366.1 66.9 395.5V504.5C66.9 509.5 64.4 512 59.4 512H7.5C2.5 512 0 509.5 0 504.5V7.5C0 2.5 2.5 0 7.5 0H59.4C64.4 0 66.9 2.5 66.9 7.5V313.5L199.2 179.7C202.8 176.2 206.3 174.4 209.8 174.4H278.9C285.9 174.4 286.8 182.3 284.2 184.9L144.3 320.3 290.2 501.5'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/kaggle.js
// module id = W6ff
// module chunks = 144